import React, { Component, useState, useRef, useEffect } from 'react';
import Select, { components } from 'react-select';
import classnames from 'classnames';
import { useTable, useFilters, useGlobalFilter, useSortBy, usePagination } from 'react-table';
import FilterConversation from '../../DropdownMenu/FilterSubmissions';

import FilterIcon from '../../../assets/images/filter-cone-icon.png';
import ConversationLink from '../../../assets/images/textsms-material.svg';
import filter_icon from '../../../assets/images/filter_icon.svg';
import filter_icon_blue from '../../../assets/images/filter_icon_blue.svg';
import utils from '../../../lib/utils';
import './index.scss';

const pageLength = 20;

const dropdownCustomStyle = {
    control: base => ({
        ...base,
        border: '1px solid #CFD0D1',
        // This line disable the blue border
        padding: '6px 12px',
        boxShadow: 'none',
        outLine: 'none',
        '&:hover': {
            border: '1px solid #CFD0D1',
        }
    }),
    option: base => ({
        ...base,
        padding: '8px 15px',
    }),
    placeholder: base => ({
        ...base,
        color: '#4A4A4A'
    }),
    indicatorsContainer: base => ({
        ...base,
        color: '#4A4A4A'
    }),
    valueContainer: base => ({
        ...base,
        padding: '2px',
        color: '#4A4A4A'
    }),
};

const DropdownIndicator = props => {
    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <i className="material-icons custom">arrow_drop_down</i>
            </components.DropdownIndicator>
        )
    );
};

const CustomOption = ({ innerProps, label, isSelected }) => {
    console.log('isSelected', isSelected);
    return <div {...innerProps} className="custom-input-option">
        <input className="custom-input-select" type="checkbox" checked={isSelected} readOnly />
        <span className="custom-input-option_lable">{label}</span>
    </div>
};

const customFilterFunction = (rows, id, filterValue) => {
    if (!filterValue || filterValue.length === 0) return rows; // No filter applied
    return rows.filter(row => filterValue.includes(row.values[id])); // Match any selected value
};

const SelectColumnFilter = ({ column: { filterValue, setFilter, preFilteredRows, id } }) => {
    const options = React.useMemo(() => {
        const options = new Set();
        preFilteredRows.forEach(row => {
            options.add(row.values[id]);
        });
        return [...options];
    }, [id, preFilteredRows]);

    return (
        <select
            value={filterValue || ''}
            onChange={e => {
                setFilter(e.target.value || undefined);
            }}
        >
            <option value="">All</option>
            {options.map((option, i) => (
                <option key={i} value={option}>
                    {option}
                </option>
            ))}
        </select>
    );
};

const FilterPopup = ({ filters, show, setShow, selectedStatus, handleFilterChange }) => {
    const popupRef = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (popupRef.current && !popupRef.current.contains(event.target)) {
                setShow(false); // Close the popup
            }
        };

        if (show) {
            document.addEventListener("mousedown", handleOutsideClick);
        }

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, [show, setShow]);
    
    return (
        <div className="filter-popup-container">
            {show && (
                <div className="filter-popup" ref={popupRef}>
                    <div className="filter-header">
                        <h4>FILTERS</h4>
                        <button onClick={() => setShow(false)}>X</button>
                    </div>
                    <div className="filter-section">
                        <label>Status</label>
                        <div className="filter-section_select-group">
                            <Select
                                components={{
                                    Option: CustomOption, DropdownIndicator, IndicatorSeparator: () => null
                                }}
                                value={filters.map(option => ({
                                    value: option,
                                    label: option,
                                })).filter(item1 => selectedStatus.some(item2 => item2.value === item1.value),
                                )}
                                isMulti
                                options={filters.map(option => ({
                                    value: option,
                                    label: option,
                                }))}
                                onChange={handleFilterChange}
                                styles={dropdownCustomStyle}
                            />

                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

const TableComponent = ({ data = [], onClickofLink }) => {
    const columns = React.useMemo(
        () => [
            {
                Header: 'Time of Submission',
                accessor: 'form_submission_time',
            },
            {
                Header: 'Client Name',
                accessor: 'user_name',
            },
            {
                Header: 'Phone Number',
                accessor: 'user_phone',
                Cell: ({ value }) => utils.formatPhoneNumber(value)
            },
            {
                Header: 'Email',
                accessor: 'user_email',
            },
            {
                Header: 'Status',
                accessor: 'status',
                Filter: SelectColumnFilter,
                filter: 'includes',
                Cell: ({ value }) => <span style={{ fontWeight: 600 }}>{value}</span>,
            },
            {
                Header: '',
                id: 'actions',
                width: 100,
                Cell: ({ row }) => (
                    <a
                        href="#"
                        onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            onClickofLink(row.original);
                        }}
                    >
                        <span className="icon-container">
                            <img id={row.original.id} src={ConversationLink} />
                        </span>
                    </a>
                ),
                getHeaderProps: () => ({
                    style: { width: '100px', minWidth: '100px', maxWidth: '100px' },
                }),
                getCellProps: () => ({
                    style: { width: '100px', minWidth: '100px', maxWidth: '100px' },
                }),
            },
        ],
        []
    );

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        rows,
        page,
        setFilter,
        prepareRow,
        state,
        setGlobalFilter,
        canPreviousPage,
        canNextPage,
        pageOptions,
        pageCount,
        gotoPage,
        nextPage,
        previousPage,
        state: { pageIndex },
    } = useTable(
        {
            columns,
            data,
            initialState: { pageIndex: 0, pageSize: pageLength },
            filterTypes: {
                includes: customFilterFunction, // Add custom filter function
            },
        },
        useFilters,
        useGlobalFilter,
        useSortBy,
        usePagination,
    );

    const renderPageNumbers = () => {
        const pages = [];
        const totalVisiblePages = 3;

        for (let i = 0; i < pageCount; i++) {
            if (
                i === 0 ||
                i === pageCount - 1 ||
                (i >= pageIndex - 1 && i <= pageIndex + 1)
            ) {
                pages.push(
                    <button
                        key={i}
                        onClick={() => gotoPage(i)}
                        className={`page-button ${pageIndex === i ? 'active' : ''}`}
                    >
                        {i + 1}
                    </button>
                );
            } else if (
                (i === pageIndex - 2 || i === pageIndex + 2) &&
                pageCount > totalVisiblePages
            ) {
                pages.push(<span key={i}>...</span>);
            }
        }
        return pages;
    };
    
    const uniqueStatusValues = React.useMemo(
        () => Array.from(new Set(data.map(row => row.status))),
        [data]
    );
    const [show, setShow] = useState(false);
    const [selectedStatus, setSelectedStatus] = useState([]);
    const [tempSelectedStatus, setTempSelectedStatus] = useState([]); // Temporary selection
    const [activeFilters, setActiveFilters] = useState({});

    const handleFilterSelection = (value) => {
        setTempSelectedStatus((prevStatus) => {
            if (prevStatus.includes(value)) {
                // Remove value if it already exists
                return prevStatus.filter((item) => item !== value);
            } else {
                // Add value if it doesn't exist
                return [...prevStatus, value];
            }
        });
    };

    const applyFilter = () => {
        // Apply the selected filters
        setSelectedStatus(tempSelectedStatus); // Update the actual selected filters
        const selectedValues = tempSelectedStatus;

        setActiveFilters((prevFilters) => {
            const updatedFilters = { ...prevFilters };
            if (selectedValues.length > 0) {
                updatedFilters['status'] = selectedValues;
            } else {
                delete updatedFilters['status'];
            }
            return updatedFilters;
        });

        setFilter('status', selectedValues); // Apply the filter to react-table
        setShow(false); // Close the popup
        console.log('Filters applied:', selectedValues);
    };

    const clearFilter = () => {
        setTempSelectedStatus([]); // Clear the temporary selection
        setSelectedStatus([]); // Clear the applied selection
        setActiveFilters((prevFilters) => {
            const updatedFilters = { ...prevFilters };
            delete updatedFilters['status'];
            return updatedFilters;
        });
        setFilter('status', undefined); // Clear the filter in react-table
    };
    const activeFilterCount = activeFilters?.status?.length || 0;
    console.log('activeFilters', activeFilters, activeFilterCount);
    return (
        <div>
            <div className="submission-header">
                <div className="submission-header_title">
                    SUBMISSIONS
                </div>
                <div className='submission-header_filter'>
                    <a
                        href="#"
                        onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            setShow(!show);
                        }}
                    >
                        <div className='filter-container'>
                            {activeFilterCount > 0 ? (<img src={filter_icon_blue} />) : (<img src={filter_icon} />)}  <span>Filter by status</span>
                            {activeFilterCount > 0 &&
                                <div className="filter-count-container"><div className="filter-count">{activeFilterCount}</div></div>
                            }
                        </div>
                    </a>
                    <FilterConversation
                        visibility={show}
                        show={show}
                        setShow={setShow}
                        position="brc"
                        onVisibilityChange={(visibility) => {
                            setShow(visibility);
                        }}
                        className="menu__dropdown conversation-filter"
                        options={uniqueStatusValues.map(option => ({
                            value: option,
                            label: option,
                        }))}
                        tempSelectedStatus={tempSelectedStatus}
                        handleFilterSelection={handleFilterSelection}
                        clearFilter={clearFilter}
                        applyFilter={applyFilter}
                    />
                </div>
                {/* <div className="submission-header_filter-list">
                    <img className="filter-icon" src={FilterIcon} onClick={() => setShow(!show)} />
                    {activeFilterCount > 0 && <span className="filter-count">{activeFilterCount}</span>}
                    <FilterPopup filters={uniqueStatusValues} setFilter={setFilter} show={show} setShow={setShow} selectedStatus={selectedStatus} handleFilterChange={handleFilterChange} />
                </div> */}
            </div>
            <table {...getTableProps()} className="submission-table">
                <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()} className="submission-table_header-row">
                            {headerGroup.headers.map((column) => (
                                <th {...column.getHeaderProps(column.getSortByToggleProps())} className="submission-table_header-row_row">
                                    <div className="submission-table_header-row_row_header-title">
                                     {column.render('Header')}
                                    <span>
                                        {column.render('Header') && (column.isSorted
                                            ? column.isSortedDesc
                                                    ? <i className="material-icons active">arrow_drop_down</i>
                                                    : <i className="material-icons active reverse">arrow_drop_down</i>
                                            : <i className="material-icons">arrow_drop_down</i>)}
                                        </span>
                                    </div>
                                </th>
                            ))}
                        </tr>
                    ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                    {page.map((row) => {
                        prepareRow(row);
                        return (
                            <tr {...row.getRowProps()} className="submission-table_body-row">
                                {row.cells.map((cell) => (
                                    <td {...cell.getCellProps()} className="submission-table_body-row_row">{cell.render('Cell')}</td>
                                ))}
                            </tr>
                        );
                    })}
                </tbody>
            </table>
            {rows.length > pageLength &&
                <div className="pagination">
                    <div className="pagination_meta">
                        Showing {pageIndex * pageLength + 1} -{' '}
                        {Math.min((pageIndex + 1) * pageLength, rows.length)} of {rows.length} submissions
                    </div>

                    <div className="pagination_controls">
                        {canPreviousPage && <button
                            onClick={() => previousPage()}
                            disabled={!canPreviousPage}
                            className="page-button-actionable"
                        >
                            PREV
                        </button>}

                        {renderPageNumbers()}

                        {canNextPage && <button
                            onClick={() => nextPage()}
                            disabled={!canNextPage}
                            className="page-button-actionable"
                        >
                            NEXT
                        </button>}
                    </div>
                </div>}
        </div>
    );
};

class Submissions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            globalFilter: '',
        };
    }

    setGlobalFilter = (value) => {
        this.setState({ globalFilter: value });
    };
    onClickofLink = (submission) => {
        const session_id = submission.business_id + '-' + submission.user_phone;
        window.open(window.Config.API_URL + `/#/app/conversation?userId=${session_id}`, "_blank");
    }
    render() {
        const { submissions } = this.props;
        return (
            <div className="submissions">
                <TableComponent data={submissions} onClickofLink={this.onClickofLink} />
            </div>
        );
    }
}

export default Submissions;